import { AfterContentInit, Component, OnInit, Renderer2,ViewChild } from '@angular/core';
import { UtilsResource } from 'src/app/resources/UtilsResource.resource';


declare var window: any;
declare var $: any;

@Component({
  selector: 'app-solutions-dos',
  templateUrl: './solutions-dos.component.html',
  styleUrls: ['./solutions-dos.component.scss']
})
export class SolutionsDosComponent implements OnInit, AfterContentInit {
  route;
  public display: boolean;
  public show: boolean;
  public itsMobile = false;
  @ViewChild("myVideo") myVideo: any;
  @ViewChild("myVideo2") myVideo2: any;
  SlideOptions = {
    items: 1,
    dots: true,
    nav: false,
    margin: 60,
    autoplay: true,
    loop: true
  };

  classesCss = {
    NAV_HIDDEN: ' nav-hidden',
    ADVANCE:' advance',
    VIDEO_HIDDEN: ' video-hidden',
    ACTIVE: 'active',
    VIDEO_VOYAGE: ' video-voyage'
  };

  sectionPrev = '';
  menu1Class = this.classesCss.NAV_HIDDEN;
  menu1BarClass = '';
  contrast:boolean = false;
  videoClass = this.classesCss.VIDEO_HIDDEN;
  videoSrc = '';
  menu2Class = this.classesCss.NAV_HIDDEN;
  menu2BarClass = '';

  sectionSettings:any = {
    'item-0': {
      idMenu: 'menu1',
      menu: {
        show: false,
        class: this.classesCss.NAV_HIDDEN,
        barClass: '',
        menuItem: ''
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }

    },
    'item-1': {
      idMenu: 'menu1',
      menu: {
        show: false,
        class: this.classesCss.NAV_HIDDEN,
        barClass: '',
        menuItem: ''
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }
    },
    'item-2': {
      idMenu: 'menu1',
      menu: {
        show: false,
        class: this.classesCss.NAV_HIDDEN,
        barClass: '',
        menuItem: ''
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }
    },
    'item-3': {
      idMenu: 'menu1',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '1',
        menuItem: 'menu1Item1'
      },
      contrast: false,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/708796109/rendition/540p/file.mp4?loc=external&signature=7d869d36b888950b2aea717530a5b86bed11d993a611e2ed82ad71cdc28bb146'
      }
    },
    'item-4': {
      idMenu: 'menu1',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '2',
        menuItem: 'menu1Item2'
      },
      contrast: false,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/717509559/rendition/540p/file.mp4?loc=external&signature=8488030acd3ff59e79edc8cb24df1b0082c9b1ac49c9fef486ac12171cbd635d'
      }
    },
    'item-5': {
      idMenu: 'menu1',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '3',
        menuItem: 'menu1Item3'
      },
      contrast: true,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }
    },
    'item-6': {
      idMenu: 'menu1',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '3',
        menuItem: 'menu1Item3'
      },
      contrast: true,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/708796680/rendition/540p/file.mp4?loc=external&signature=86dc140c64f332530f728b9af20c146a9fa9214f5236b57ab6eed93d1f79c05e'
      }
    },
    'item-7': {
      idMenu: 'menu1',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '3',
        menuItem: 'menu1Item3'
      },
      contrast: true,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/708796680/rendition/540p/file.mp4?loc=external&signature=86dc140c64f332530f728b9af20c146a9fa9214f5236b57ab6eed93d1f79c05e'
      }
    },
    'item-8': {
      idMenu: 'menu1',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '3',
        menuItem: 'menu1Item3'
      },
      contrast: true,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/708796680/rendition/540p/file.mp4?loc=external&signature=86dc140c64f332530f728b9af20c146a9fa9214f5236b57ab6eed93d1f79c05e'
      }
    },
    'item-9': {
      idMenu: 'menu1',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '4',
        menuItem: 'menu1Item4'
      },
      contrast: false,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/718102535/rendition/540p/file.mp4?loc=external&signature=64a1cbb429a5203c5ce5f858324181ce98ceaef0c64d133135e4e1729b39f6c4'
      }
    },
    'item-10': {
      idMenu: 'menu1',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '4',
        menuItem: 'menu1Item4'
      },
      contrast: false,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/708796744/rendition/540p/file.mp4?loc=external&signature=bcfff9fdc9017a5c9ecfafd40d1d528b5974f322cef460b0837eac8a7547e001'
      }
    },
    'item-11': {
      idMenu: 'menu1',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '4',
        menuItem: 'menu1Item4'
      },
      contrast: false,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/709268505/rendition/540p/file.mp4?loc=external&signature=7f7ce20d177564c28d680689afd112dcdb72ad39ca943fc8de979e2c23035eb8'
      }
    },
    'item-12': {
      idMenu: 'menu1',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '5',
        menuItem: 'menu1Item5'
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }
    },
    'item-13': {
      idMenu: 'menu1',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '6',
        menuItem: 'menu1Item5_1'
      },
      contrast: false,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/597824056/rendition/540p/file.mp4?loc=external&signature=bb9237d96d4b070767560cc45237183ad82465239aa1279c5149862e09c94fbb'
      }
    },
    'item-14': {
      idMenu: 'menu1',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '7',
        menuItem: 'menu1Item5_2'
      },
      contrast: false,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/708795656/rendition/540p/file.mp4?loc=external&signature=7b1a4be2075d8e5532277a2699c0c57582ed748c97661bd67d25f9cb97c71f1f'
      }
    },
    'item-15': {
      idMenu: 'menu1',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '8',
        menuItem: 'menu1Item5_3'
      },
      contrast: false,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/597824068/rendition/540p/file.mp4?loc=external&signature=7e76f8925db0be1a575d5928c89236a4056104f010b2403166ff28eb835ea362'
      }
    },
    'item-16': {
      idMenu: 'menu1',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '9',
        menuItem: 'menu1Item5_4'
      },
      contrast: false,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/708796132/rendition/540p/file.mp4?loc=external&signature=3241aef233ad4b523cbbee6f6747172c56a0450af8b784fa6c76bd96876e9ae4'
      }
    },
    'item-17': {
      idMenu: 'menu1',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '10',
        menuItem: 'menu1Item6'
      },
      contrast: false,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/708796391/rendition/540p/file.mp4?loc=external&signature=4d820af00efcc0dd70c6362c23c7110976ee6baf1a4177c88a1c61b89734dc64'
      }
    },
    'item-18': {
      idMenu: 'menu1',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '11',
        menuItem: 'menu1Item7'
      },
      contrast: false,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/708796301/rendition/540p/file.mp4?loc=external&signature=7493958eadc11c0c074951dbb2db87b3c8783b397e587516fa17530e75c0221d'
      }
    },
    'item-19': {
      idMenu: 'menu1',
      menu: {
        show: false,
        class: this.classesCss.NAV_HIDDEN,
        barClass: '',
        menuItem: ''
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }
    },
    'item-20': {
      idMenu: 'menu1',
      menu: {
        show: false,
        class: this.classesCss.NAV_HIDDEN,
        barClass: '',
        menuItem: ''
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }
    },
    'item-21': {
      idMenu: 'menu2',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '1',
        menuItem: 'menu2Item1'
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }
    },
    'item-22': {
      idMenu: 'menu2',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '2',
        menuItem: 'menu2Item2'
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }
    },
    'item-23': {
      idMenu: 'menu2',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '3',
        menuItem: 'menu2Item3'
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }
    },
    'item-24': {
      idMenu: 'menu2',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '4',
        menuItem: 'menu2Item4'
      },
      contrast: false,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/708796196/rendition/540p/file.mp4?loc=external&signature=ff4da48eb4d50ff0872860d4730e98dd4dddd997a2702d1f84fdef5e1ecbbd46'
      }
    },
    'item-25': {
      idMenu: 'menu2',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '5',
        menuItem: 'menu2Item5'
      },
      contrast: false,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/708796214/rendition/540p/file.mp4?loc=external&signature=a32fc63428b27f0a3cdf3145b8fb874c5f189ffb765fd09e6493f0d4410e82cb'
      }
    },
    'item-26': {
      idMenu: 'menu2',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '6',
        menuItem: 'menu2Item6'
      },
      contrast: false,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/718154624/rendition/540p/file.mp4?loc=external&signature=ab3b86edf88d96722274a9bdd97fa41ea581b5debab7ebb4efef10a49f084798'
      }
    },
    'item-27': {
      idMenu: 'menu2',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '7',
        menuItem: 'menu2Item7'
      },
      contrast: false,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/708796301/rendition/540p/file.mp4?loc=external&signature=7493958eadc11c0c074951dbb2db87b3c8783b397e587516fa17530e75c0221d'
      }
    },
    'item-28': {
      idMenu: 'menu2',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '8',
        menuItem: 'menu2Item8'
      },
      contrast: false,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/597824056/rendition/540p/file.mp4?loc=external&signature=bb9237d96d4b070767560cc45237183ad82465239aa1279c5149862e09c94fbb'
      }
    },
    'item-29': {
      idMenu: 'menu2',
      menu: {
        show: true,
        class: this.classesCss.NAV_HIDDEN,
        barClass: this.classesCss.ADVANCE + '9',
        menuItem: 'menu2Item9'
      },
      contrast: false,
      video: {
        show: true,
        class: this.classesCss.VIDEO_HIDDEN,
        src: 'https://player.vimeo.com/progressive_redirect/playback/708795799/rendition/540p/file.mp4?loc=external&signature=6b12a94f7f023b449b4c12b62d50a062dfc811e73390c1b34271caaeec8e4352'
      }
    },
    'item-30': {
      idMenu: 'menu2',
      menu: {
        show: false,
        class: this.classesCss.NAV_HIDDEN,
        barClass: '',
        menuItem: ''
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }
    },
    'item-31': {
      idMenu: 'menu2',
      menu: {
        show: false,
        class: this.classesCss.NAV_HIDDEN,
        barClass: '',
        menuItem: ''
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }
    },
    'item-32': {
      idMenu: 'menu2',
      menu: {
        show: false,
        class: this.classesCss.NAV_HIDDEN,
        barClass: '',
        menuItem: ''
      },
      contrast: false,
      video: {
        show: false,
        class: this.classesCss.VIDEO_HIDDEN,
        src: ''
      }
    }
  };

  constructor(
    private render: Renderer2
  ) {
    this.route = window.location.hash;
  }

  ngAfterContentInit(): void {
    setTimeout(() => {
      if (this.itsMobile) {
        try {
          const sectionSettingsKeys = Object.keys(this.sectionSettings)
          Object.values(this.sectionSettings).forEach((item:any, index) => { 
            if(item.video && item.video.show) {
              this.loadSrcVideo(`${sectionSettingsKeys[index]}-video`, item.video.src);
            }})
        } catch(error) {
          UtilsResource.ShowLog('*** SolutionsDosComponent - ngOnInit - error', error);
        }
      }
    });
  }

  ngOnInit(): void {
    if (this.verifyMobile()) {
      this.itsMobile = true;
    }
    for (let position = 0; position <= 32; position++) {
      const target = document.getElementById('item-' + position);
      if (target != null) {
        this.createObserver(target);
      }
    }
  }

  createObserver(target: Element) {
    const options = {
      root: null,
      threshold: 0.9
    };

    const that = this;
    const observer = new IntersectionObserver((entries: any[], observer: any) => {
      entries.forEach((entry) => {
        if(entry.isIntersecting) {
          UtilsResource.ShowLog(entry.target.id, 'visible state', entry.isIntersecting, 'height', entry.target.clientHeight);
          that.loadSectionSettings(entry);
          that.sectionPrev = entry.target.id;
        }
      });
    }, options);
    observer.observe(target);
  }

  loadSectionSettings(entry) {
    const up = Number(this.sectionPrev.replace('item-', '')) > Number(entry.target.id.replace('item-',''))
    if (this.sectionSettings[entry.target.id]) {
      const sectionSettings = this.sectionSettings[entry.target.id];
      if (sectionSettings.idMenu == 'menu1') {
        this.menu2Class = this.classesCss.NAV_HIDDEN;
        if (sectionSettings.menu.show) {
          this.menu1Class = this.menu1Class.replace(sectionSettings.menu.class, '');
          const menuItem = document.getElementById(sectionSettings.menu.menuItem);
          if (up) {
            this.loadPrev();
          }
          if (menuItem) {
            this.render.addClass(menuItem, this.classesCss.ACTIVE);
          }
          if (this.menu1BarClass.lastIndexOf(sectionSettings.menu.barClass) == -1) {
            this.menu1BarClass += sectionSettings.menu.barClass;
          }
        } else {
          if (this.menu1Class.lastIndexOf(sectionSettings.menu.class) == -1) {
            this.menu1Class += sectionSettings.menu.class;
          }
        }
        if (sectionSettings.contrast) {
          this.contrast = sectionSettings.contrast;
        } else {
          this.contrast = false;
        }

        if (sectionSettings.video.show) {
          this.videoClass = this.videoClass.replace(sectionSettings.video.class, '');
          this.videoSrc = sectionSettings.video.src;
          if (this.itsMobile) {
            if(this.myVideo.nativeElement.currentTime > 0) {
              this.myVideo.currentTime === 0;
              this.myVideo.nativeElement.load();
              console.log("video********************* 2", this.myVideo.currentTime )
            }
            try {
              
              const video:any = document.getElementById(`${entry.target.id}-video`);
              
         
              if(this.myVideo.nativeElement.currentTime > 0) {
                this.myVideo.nativeElement.currentTime = 0
                this.myVideo.play();
                console.log("video********************* 2", this.myVideo)
              }
            } catch (error) {
              UtilsResource.ShowLog('*** SolutionsDosComponent - loadSectionSettings - error', error);
            }
          }
        } else {
          if (this.videoClass.lastIndexOf(sectionSettings.video.class) == -1) {
            this.videoClass += sectionSettings.video.class;
          }
        }
      } else if (sectionSettings.idMenu == 'menu2') {
        this.menu1Class = this.classesCss.NAV_HIDDEN;
        if (sectionSettings.menu.show) {
          this.menu2Class = this.menu1Class.replace(sectionSettings.menu.class, '');
          const menuItem = document.getElementById(sectionSettings.menu.menuItem);
          if (up) {
            this.loadPrev();
          }
          if (menuItem) {
            this.render.addClass(menuItem, this.classesCss.ACTIVE);
          }
          if (this.menu2BarClass.lastIndexOf(sectionSettings.menu.barClass) == -1) {
            this.menu2BarClass += sectionSettings.menu.barClass;
          }
        } else {
          if (this.menu2Class.lastIndexOf(sectionSettings.menu.class) == -1) {
            this.menu2Class += sectionSettings.menu.class;
          }
        }
        if (sectionSettings.contrast) {
          this.contrast = sectionSettings.contrast;
        } else {
          this.contrast = false;
        }
        if (sectionSettings.video.show) {
          this.videoClass = this.videoClass.replace(sectionSettings.video.class, '');
          this.videoSrc = sectionSettings.video.src;
          if (this.itsMobile) {
            try {
              this.myVideo.nativeElement.currentTime = 0             
              const video:any = document.getElementById(`${entry.target.id}-video`);
              if(this.myVideo) {
                this.myVideo.play();
                this.myVideo.nativeElement.currentTime = 0
                console.log("video*********************", this.myVideo)
              }
            } catch (error) {
              UtilsResource.ShowLog('*** SolutionsDosComponent - loadSectionSettings - error', error);
            }
          }          
        } else {
          if (this.videoClass.lastIndexOf(sectionSettings.video.class) == -1) {
            this.videoClass += sectionSettings.video.class;
          }
        }
      }

      if (this.contrast) {
        if (this.videoClass.lastIndexOf(this.classesCss.VIDEO_VOYAGE) == -1) {
          this.videoClass += this.classesCss.VIDEO_VOYAGE;
        }
      } else {
        this.videoClass = this.videoClass.replace(this.classesCss.VIDEO_VOYAGE, '');
      }
    }
  }

  loadPrev() {
    const sectionSettings = this.sectionSettings[this.sectionPrev];
    const menuItem = document.getElementById(sectionSettings.menu.menuItem);
    if (sectionSettings.idMenu == 'menu1') {
      this.menu1BarClass = this.menu1BarClass.replace(sectionSettings.menu.barClass, '');
      if (menuItem) {
        this.render.removeClass(menuItem, this.classesCss.ACTIVE);
      }
    } else if (sectionSettings.idMenu == 'menu2') {
      this.menu2BarClass = this.menu2BarClass.replace(sectionSettings.menu.barClass, '');
      if (menuItem) {
        this.render.removeClass(menuItem, this.classesCss.ACTIVE);
      }
    }
  }

  Navigate(elem: HTMLElement) {
    elem.scrollIntoView({ behavior: 'smooth' });
  }

  verifyMobile(): any {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i
    ];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

  menuClick(idMenu, menuItem) {
    const index = Object.values(this.sectionSettings).findIndex((item:any) => item.idMenu == idMenu && item.menu.menuItem == menuItem);
    UtilsResource.ShowLog('*** SolutionsDosComponent - menuClick - idMenu - menuItem - index', idMenu, menuItem, index);
    if (index && index > -1) {
      const sectionKeys = Object.keys(this.sectionSettings);
      const element = sectionKeys[index];
      if (element) {
        document.getElementById(element).scrollIntoView();
        this.menu1BarClass = '';
        this.menu2BarClass = '';
        $(`.${this.classesCss.ACTIVE}`,$(`#${idMenu}`)).removeClass(this.classesCss.ACTIVE);
        for (let position = 0; position <= index; position++) {
          const entry = {
            target: {
              id: sectionKeys[position]
            }
          }
          this.loadSectionSettings(entry)
        }
      }
    }
  }

  pauseAllVideos() {
    try {
      const videos = $('video'); 
      $.each(videos, (index, value) => {
        value.pause();
      });
    } catch (error) {
      UtilsResource.ShowLog('*** SolutionsDosComponent - pauseAllVideos - error', error);
    }
  }

  loadSrcVideo(idVideo:string, src:string) {
    try {
      const video:any = document.getElementById(idVideo);
      if(video) {
        video.setAttribute('src', src);
        video.load();
      }
    } catch (error) {
      UtilsResource.ShowLog('*** SolutionsDosComponent - loadSrcVideo - error', error);
    }
  }
}